<template>

  <div>

    <v-btn-toggle class="mt-2 mb-4" v-model="allocationView" @change="onChangeAllocationView">
      <v-btn small>default</v-btn>
      <v-btn small>ternary</v-btn>
      <v-btn small>fork</v-btn>
      <v-btn small>expression</v-btn>
    </v-btn-toggle>

    <v-row :key="allocationView" v-if="allocationView != 3">

      <v-col>
        <v-select
          :items="scopes"
          v-model="data.scope"
          item-text="name"
          item-value="name"
          label="Scope"
        />
      </v-col>

      <v-col>

        <template v-if="data.scope == 'constants'">

          <v-select
            :items="scopes.find(s => s.name == data.scope).attributes"
            v-model="data.field"
            item-text="name"
            item-value="id"
            label="Konstante"
          />

        </template>

        <template v-else-if="data.scope == 'value'">

            <v-text-field v-model="data.field" label="Value" />

        </template>

        <template v-else-if="data.scope == 'Stage Input'">

        </template>

        <template v-else>

          <v-select
            v-if="data.scope != null"
            :items="scopes.find((s) => s.name == data.scope ).attributes"
            v-model="data.field"
            item-text="label"
            item-value="name"
            label="Attribute"
          >
          </v-select>

        </template>
      </v-col>

    </v-row>


    <!-- ternary -->
    <template v-if="allocationView == 1">

      <scope-field-selector
        :scopes="scopes"
        :scope="data.ternary.a.scope"
        @scope="data.ternary.a.scope = $event"
        :field="data.ternary.a.field"
        @field="data.ternary.a.field = $event"
      >
        <template #header>a</template>

      </scope-field-selector>


      <scope-field-selector
        :scopes="scopes"
        :scope="data.ternary.b.scope"
        @scope="data.ternary.b.scope = $event"
        :field="data.ternary.b.field"
        @field="data.ternary.b.field = $event"
      >
        <template #header>b</template>

      </scope-field-selector>

    </template>

    <!-- fork -->
    <template v-else-if="allocationView == 2">

      <scope-field-selector
        :scopes="scopes"
        :scope="data.fork.lowerLimit.scope"
        @scope="data.fork.lowerLimit.scope = $event"
        :field="data.fork.lowerLimit.field"
        @field="data.fork.lowerLimit.field = $event">

        <template #header>lowerLimit</template>

      </scope-field-selector>

      <scope-field-selector
        :scopes="scopes"
        :scope="data.fork.upperLimit.scope"
        @scope="data.fork.upperLimit.scope = $event"
        :field="data.fork.upperLimit.field"
        @field="data.fork.upperLimit.field = $event">

        <template #header>upperLimit</template>

      </scope-field-selector>


      <scope-field-selector
        :scopes="scopes"
        :scope="data.fork.a.scope"
        @scope="data.fork.a.scope = $event"
        :field="data.fork.a.field"
        @field="data.fork.a.field = $event">
        <template #header>a</template>

      </scope-field-selector>

      <scope-field-selector
        :scopes="scopes"
        :scope="data.fork.b.scope"
        @scope="data.fork.b.scope = $event"
        :field="data.fork.b.field"
        @field="data.fork.b.field = $event"
      >
        <template #header>b</template>

      </scope-field-selector>

      <scope-field-selector
        :scopes="scopes"
        :scope="data.fork.c.scope"
        @scope="data.fork.c.scope = $event"
        :field="data.fork.c.field"
        @field="data.fork.c.field = $event"
      >
        <template #header>c</template>

      </scope-field-selector>

    </template>

    <!-- expression -->
    <template v-else-if="allocationView == 3">

      <allocation-expression
        :scopes="scopes"
        :operators="[ { name: 'default', label: 'default' }, ... ruleSettings.exprOperators]"
        v-for="(term, termIndex) in data.expr.terms" :key="term"
        :termIndex="termIndex"
        :term="term"

        @value="data.expr.terms[termIndex].value = $event"
        @field="data.expr.terms[termIndex].field = $event"
        @scope="data.expr.terms[termIndex].scope = $event"
        @operator="data.expr.terms[termIndex].operator = $event"

        @addExprBlock="addExprBlock"
        @deleteExprBlock="deleteExprBlock"
        >

      </allocation-expression>

      <div>
        <v-row>

          <v-col cols="12">

            <v-btn block tile elevation="0" @click="addExprBlock">
              <v-icon left>mdi-plus</v-icon><lang t="RULE-ADD_EXPRESSION" />
            </v-btn>

          </v-col>

        </v-row>
      </div>

    </template>

  </div>

</template>


<script>
import scopeFieldSelector from './ScopeFieldSelector';
import allocationExpression from './RulesEditor-Allocation-Expression';

export default {

  components: {
    scopeFieldSelector,
    allocationExpression
  },

  props: {

    scopes: {
      type: Array,
      default: []
    },

    ruleSettings: {
      type: Array,
      default: [],
    },

    allocation: {
      type: Object
    }

  },

  data() {

    return {
      allocationView: 0,
      data: null
    }

  },

  created() {

    if(this.allocation.expr) {
      this.allocationView = 3;
    }
    else if(this.allocation.fork) {
      this.allocationView = 2;
    }
    else if(this.allocation.ternary) {
      this.allocationView = 1;
    }
    else {
      this.allowCationView = 0;
    }

    this.data = this.allocation;

  },


  watch: {

    data: {
      deep: true,
      handler() {

        if(this.data.scope == 'Stage Input') {
          this.data.field = null;
        }
        this.$emit('update', this.data);
      }
    }

  },


  computed: {

    scopeOptions() {
      return this.scopes.find(s => s.name == this.data.scope ).attributes;
    }

  },

  methods: {

    addExprBlock() {

      this.data.expr.terms.push(
        {
          scope: null,
          value: null,
          field: null,
          operator: 'default'
        }
      );

    },

    deleteExprBlock(index) {

      this.data.expr.terms.splice(index, 1);

    },


    onChangeAllocationView(view) {

      // default
      if(view == 0) {

        this.data = {
          scope: this.data.scope != 'expr' ? this.data.scope : 'constants',
          field: this.data.field,
        }

      }

      // ternary
      else if(view == 1) {

        this.data = {
          scope: this.data.scope != 'expr' ? this.data.scope : 'constants',
          field: this.data.field,
          ternary: {
            a: {
              scope: null,
              field: null,
            },
            b: {
              scope: null,
              field: null,
            }
          },
        }
      }

      // fork
      else if (view == 2) {

        this.data = {
          scope: this.data.scope != 'expr' ? this.data.scope : 'constants',
          field: this.data.field,
          fork: {
            a: {
              scope: null,
              field: null,
            },
            b: {
              scope: null,
              field: null,
            },
            c: {
              scope: null,
              field: null,
            },
            lowerLimit: {
              scope: null,
              field: null,
            },
            upperLimit: {
              scope: null,
              field: null,
            },
          }
        }
      }

      // expression
      else if (view == 3) {

        this.data = {
          scope: 'expr',
          field: '',
          expr: {
            terms: [
              {
                scope: null,
                value: null,
                field: null,
                operator: 'default'
              },
              {
                scope: null,
                value: null,
                field: null,
                operator: 'default'
              }
            ]
          }
        }

      }

    },
  }
}
</script>


<style lang="scss">


</style>
